export const PAGE_URL = {
  LOGIN: "/",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_SUCCESS: "/reset-password-success",
  CREATE_PASSWORD: "/create-password",
  CREATE_PASSWORD_SUCCESS: "/create-password-success",
  DOCUMENTS: "/documents",
  DOCUMENT: "/document",
  REDIRECTION: "/redirect",
  SETTINGS: "/settings",
  STATUS: '/analysis',
  FEEDBACK: '/feedback',
  FEEDBACKS: '/feedbacks',
  OTHERS: '/others'
};

export const PAGE_TITLE = [
  { route: PAGE_URL.DOCUMENT, title: "Overview", displayBackButton: true },
  { route: PAGE_URL.DOCUMENTS, title: "Overview", displayBackButton: false },
  { route: PAGE_URL.SETTINGS, title: "Settings", displayBackButton: true },
  { route: PAGE_URL.STATUS, title: "Dashboard", displayBackButton: false },
  { route: PAGE_URL.FEEDBACK, title: "Feedback Insights", displayBackButton: false },
  { route: PAGE_URL.FEEDBACKS, title: "Feedbacks", displayBackButton: false },
  { route: PAGE_URL.OTHERS, title: "Others", displayBackButton: false },
  {
    route: PAGE_URL.REDIRECTION,
    title: "Authentication",
    displayBackButton: false,
  },
];
